import { ENDPOINT } from "../../constants/endpoint.js"
import axios from 'axios'
import Swal from "sweetalert2";
import router from '../../router'

const state = {
  accessEmail: 'anuwat@outputstream.net',
  accessToken: 'Cw7C42a5EseQ4nHoJyd6',
  loading: false,
  dataVessel: [],
  vesselGroupsData: [],
  filterVessel: [],
};

const mutations = {
  LOADING: (state, payload) => {
    state.loading = payload.loading
  },
  UPDATE_VESSEL(state, dataVessel) {
    state.dataVessel = dataVessel;  
  },
  VESSEL_GROUP(state,vesselGroup){
    state.vesselGroupsData = vesselGroup
  },
  UPDATE_FILTER(state, value) {
    state.filterVessel = value;
  },
}
const actions = {
  updateVessel({ commit }, dataVessel) {
    commit('UPDATE_VESSEL', dataVessel)
  },
  updateFilterVessel({ commit }, value) {
    commit('UPDATE_FILTER', value)
  },
  getVesselGroups({ commit }) {
    // console.log("accessEmail ", accessEmail);
    // console.log("accessToken ", accessToken);
    const url = ENDPOINT.API_ADMIN_VESSEL_GROUP;
    axios
      .get(url, {
        params: {
          limit: 10
        },
        headers: {
          "X-User-Email": 'anuwat@outputstream.net',
          "X-User-Token": 'Cw7C42a5EseQ4nHoJyd6'
        }
      })
      .then(async(response) => {
        console.log("response.data ", response.data);
        await commit("VESSEL_GROUP", response.data);
        // this.$store.dispatch("updateVesselGroups", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
